import { AssociatedMediasResource } from "./associated-medias";
import { Cachable } from "./cachable"
import { SkinDate } from "./skin-date";
import { TranslatedString } from "./translated-string";
import { LifecycleStateResource, LinkableArchiveItemResource } from "./workflow-schema";

export enum RecordLifecycleState {
    IN_PROGRESS = 'inProgress',
    TO_VALIDATED = 'toValidated',
    VALIDATED = 'validated'
}

export interface Record extends Cachable {
    id: string;
    associatedMedias?: AssociatedMediasResource | null

    recolementIdentificationSchema?: RecolementIdentificationSchemaResource
    recolementPropertyStatusSchema?: RecolementPropertyStatusSchemaResource
    recolementFollowUpActionSchema?: RecolementFollowUpActionSchemaResource
    recolementCheckingSchema?: RecolementCheckingSchemaResource
    recolementLinkSchema?: RecolementLinkSchemaResource
    workflowSchema?: RecolementWorkflowSchemaResource

    // only exists in reporter cached update, does not exists on Tryphon
    tempOfflineSchema?: TempOfflineSchema
}

interface TempOfflineSchema {
    auditCampaign?: string
}

interface RecolementIdentificationSchemaResource {
    numberIdentifier?: string
    date?: SkinDate
    recoleur?: string[]
    authorizedAuditor?: string[]
    supervisor?: string
    context?: TranslatedString
    recolements?: string[]
    validationDate?: SkinDate
    recolementType?: string 
}

interface RecolementPropertyStatusSchemaResource {
    integrity?: boolean
    deformationInstability?: boolean
    tracesHumidity?: boolean
    tracesInfestation?: boolean
    highDust?: boolean
    commentOnSpecificPoints?: CommentOnSpecificPointResource[]
}

interface CommentOnSpecificPointResource {
    commentary?: TranslatedString
    typeOfCommentary?: TranslatedString
}

interface RecolementFollowUpActionSchemaResource {
    inventoried?: boolean
    inventoriedOn?: SkinDate
    marked?: boolean
    markedOn?: SkinDate
    photographed?: boolean
    photoGraphedOn?: SkinDate
    processed?: boolean
    processedOn?: SkinDate
    processingDetail?: TranslatedString
    located?: boolean
    locatedOn?: SkinDate
    compliant?: boolean
    compliantFiledOn?: SkinDate
    identificationProblem?: boolean
    additionalSearch?: boolean
    additionalSearchCommentary?: TranslatedString
    commentIdentification?: TranslatedString
    destroyed?: boolean
    missing?: boolean
    temporaryExit?: boolean
    lastObjectMovement?: string
    temporaryExitComment?: TranslatedString
    harvestedLater?: boolean
    commentOnAction?: TranslatedString
    existDocPhotography?: boolean
    photographyInRecolement?: boolean
    marksPhotography?: boolean
    identifierNumberPhotography?: boolean
    toDeaccession?: boolean
    reportJoconde?: boolean
    toIdentify?: boolean
    toMeasureToWeigh?: boolean
    batchDetailed?: boolean
    provenDestroyed?: boolean 
}

interface RecolementCheckingSchemaResource {
    localized?: boolean
    presenceInventoryNumber?: boolean
    identifiable?:  boolean
    markedOnObject?: boolean
    markedOnLabel?: boolean
    markedOnSupport?: boolean
    supportCommentary?: TranslatedString
    otherNumber?: boolean
    otherNumberCommentary?: TranslatedString
    compliantRegister?: boolean
    recolementSources?: RecolementSourceResource[]
    commentaryCompliant?: TranslatedString 
    permanentAuditLocation?: string
    currentLocation?: string 
    generalStatus?: TranslatedString
    stolen?: boolean
    locatedButNotRegistered?: boolean
    exhibitedStored?: boolean
    objectInventoriedSeveralTimes?: boolean
    duplicateComment?: TranslatedString
    duplicatedItemsLinks?: LinkableArchiveItemResource[]
}

interface RecolementSourceResource {
    typeOfSource?: TranslatedString
    name?: TranslatedString
    precision?: TranslatedString 
}

interface RecolementLinkSchemaResource {
    linkedItem?: LinkableArchiveItemResource
}

interface RecolementWorkflowSchemaResource {
    currentState?: LifecycleStateResource
}